<template>
    <div>
        <b-navbar toggleable="lg" type="dark" variant="secondary">
            <!-- <b-navbar-brand href="#">Dashboards</b-navbar-brand> -->

            <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav>
                    <b-nav-item :to="{ name: 'managementDashboards' }"
                        >Indicadores de supervisión</b-nav-item
                    >
                    <b-nav-item :to="{ name: 'managementIndicators' }"
                        >Indicadores de lideres</b-nav-item
                    >
                    <!-- <b-nav-item href="#">PQRs</b-nav-item> -->
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>

        <div>
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        //
    },
    data: () => ({
        //
    }),
    methods: {
        //
    },
}
</script>
